import React, { Component } from 'react';
import PricingSection from '../../pricing';
import './index.css';

class PricingBoxSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
    this.invoiceClickHandler = this.invoiceClickHandler.bind(this);
  }

  invoiceClickHandler(pdfInfo){
    this.props.onInvoiceClick(pdfInfo);

  }

  render() {
    const { lang } = this.props;
    return (
      <div>
          <PricingSection lang={lang} onInvoiceClick={this.invoiceClickHandler}/>
      </div>
    );
  }
}


export default PricingBoxSection;
